export default __webpack_public_path__ + "static/media/ic_croatia.e8f6064b.svg";